import s from './Empty.module.scss';

type TEmptyProps = {
    message?: string;
};

export const Empty = ({ message = 'No data available yet.' }: TEmptyProps) => {
    return (
        <div className={s.empty}>
            <p className={s.empty_text}>{message}</p>
        </div>
    );
};
